import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import styles from './index.module.scss'
import clsx from 'clsx'
import BidCountdown from '@components/BidCountdown/BidCountdown'
import { useEffect, useState } from 'react'
import classNames from 'classnames'
import { PictureItem } from '@components/ItemPage/utils/types'
import ImageZoom from '@components/ItemPage/Images/BidItemCarousel/ImageZoom'
const CarouselComponent = ({
  pictureList,
  date,
  hasEnded,
}: {
  pictureList: PictureItem[]
  date: string
  hasEnded: boolean
}) => {
  const [nav1, setNav1] = useState<Slider | null>(null)
  const [nav2, setNav2] = useState<Slider | null>(null)
  const [slider1, setSlider1] = useState<Slider | null>(null)
  const [slider2, setSlider2] = useState<Slider | null>(null)
  useEffect(() => {
    setNav1(slider1)
    setNav2(slider2)
  }, [slider1, slider2])

  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dotsClass: clsx('slick-dots', styles.dotsClass),
  }

  const thumbnailSettings = {
    slidesToShow: Math.min(5, pictureList.length),
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    swipeToSlide: true,
    focusOnSelect: true,
    arrows: false,
    infinite: false,
    variableWidth: pictureList.length < 5,
  }

  const lotterStyle = 'text-white bg-bidfta-blue-dark border-[1px] border-white'
  const stockStyle = 'text-black bg-[#F5F5F5] border-[1px] border-black '

  return (
    <>
      <div className={styles.carouselContainer}>
        <Slider
          {...settings}
          asNavFor={nav2 ? nav2 : undefined}
          ref={(slider) => setSlider1(slider)}
        >
          {pictureList.map(({ picUrl, lotterPicture }, i) => (
            <div key={`picture-${i}`} className={styles.imageContainer}>
              <ImageZoom
                src={picUrl}
                alt={`Image ${i}`}
                className={styles.carouselImage}
              />
              <div
                className={classNames(
                  'flex gap-1 items-center font-bold absolute top-4 right-0 py-2 px-4 text-xs z-10',
                  lotterPicture ? lotterStyle : stockStyle
                )}
              >
                {lotterPicture ? 'BIDFTA' : 'STOCK'} IMAGE
              </div>
            </div>
          ))}
        </Slider>
        <div className="absolute bottom-3 right-2 bg-[#ea4a4a] text-white py-2 px-4 rounded-full text-sm z-20">
          <BidCountdown
            date={date}
            itemClosed={hasEnded}
            textClass="white"
            hideEnds={true}
          />
        </div>
      </div>

      <div
        className={classNames(
          styles.thumbnailWrapper,
          pictureList.length < 5 ? styles.lessPictures : ''
        )}
      >
        <Slider
          {...thumbnailSettings}
          asNavFor={nav1 || undefined}
          ref={(slider) => setSlider2(slider)}
        >
          {pictureList.map(({ picUrl }, i) => (
            <div key={`picture-${i}`}>
              <img
                src={picUrl}
                alt={picUrl}
                className={styles.current}
                style={{ objectFit: 'cover', height: '4rem', width: '4rem' }}
              />
            </div>
          ))}
        </Slider>
      </div>
    </>
  )
}

export default CarouselComponent
